<template>
    <div class="mobile-list-wrapper">
        <div class="mobile-wrapper">
            <div class="card text-center">
                <el-button class="list-btn bg-orange" type="warning" @click="createCashIncome" v-if="canCreateCashIncome">
                    новый приход @
                </el-button>
                <el-button class="list-btn bg-orange" type="warning" @click="createCashLessIncome" v-if="canCreateCashLessIncome">
                    новый приход безнал
                </el-button>
            </div>
            <div v-if="incomes.length">
                <div
                    class="list-item card"
                    v-for="income in incomes"
                    :key="income.id"
                    @click="goCard(income)"
                >
                    <template v-for="(column, index) in columnDefs">
                        <div class="list-item-id list-item-row" :key="index">
                            <div class="label">
                                {{ column.headerName }}:
                            </div>
                            <div class="value">
                                {{ income[column.field] }}
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="card" v-else>
                Список пуст
            </div>
        </div>
    </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import '@/assets/styles/list.scss';
import '@/assets/styles/card-complex.scss';
import localReferences from '@/helpers/localReferences';

export default {
    name: 'DealIncomesMobile',
    data() {
        return {
            localReferences,
            columnDefs: [
                { headerName: 'id', field: 'id' },
                { headerName: 'Дата создания', field: 'created_at' },
                { headerName: 'Создан', field: 'created_by_name' },
                { headerName: 'Дата прихода', field: 'date' },
                { headerName: 'Статус операции', field: 'operation_status_name' },
                { headerName: 'Принял', field: 'received_by_name' },
                { headerName: 'Получено у', field: 'received_from_name' },
                { headerName: 'Вид оплаты', field: 'pay_type_name' },
                { headerName: 'Сумма', field: 'amount_formatted' },
                { headerName: 'Комментарий', field: 'comment' }
            ],
            loading: false,
            data: {}
        };
    },
    props: {
        dealId: {
            type: [String, Number],
            default: 0
        }
    },
    computed: {
        incomes() {
            return this.$store.state.incomes.incomes;
        },
        isIncomeCashEmployer() {
            return this.$store.getters.isIncomeCashEmployer;
        },
        isIncomeCashDirector() {
            return this.$store.getters.isIncomeCashDirector;
        },
        isIncomeCashLessAccountant() {
            return this.$store.getters.isIncomeCashLessAccountant;
        },
        isIncomesCashLessEmployer() {
            return this.$store.getters.isIncomesCashLessEmployer;
        },
        canCreateCashIncome() {
            return this.isIncomeCashEmployer || this.isIncomeCashDirector;
        },
        canCreateCashLessIncome() {
            return this.isIncomesCashLessEmployer || this.isIncomeCashLessAccountant;
        }
    },
    beforeMount() {
        this.getIncomes(this.dealId);
    },
    methods: {
        async getIncomes(dealId) {
            const requestParams = {
                size: 1000,
                page: 1,
                sort: [{ colId: 'date', sort: 'desc' }],
                filter: { deal_id: dealId }
            };
            this.loading = true;
            this.$store.dispatch('incomes/getPaginatedList', requestParams).then(
                () => {
                }).finally(() => {
                this.loading = false;
            });
        },
        getRouteForCard(data) {
            const params = { id: '' + data.id };
            if (this.localReferences.payTypesCash.includes(data.pay_type_id)) {
                return { name: 'income-cash-card-view', params };
            }
            if (this.localReferences.payTypesCashless.includes(data.pay_type_id)) {
                return { name: 'income-cashless-card-view', params };
            }
        },
        goCard(income) {
            this.$router.push(this.getRouteForCard(income));
        },
        createCashIncome() {
            const params = { id: 'new', dealId: '' + this.dealId };
            this.$router.push({ name: 'income-cash-card', params });
        },
        createCashLessIncome() {
            const params = { id: 'new', dealId: '' + this.dealId };
            this.$router.push({ name: 'income-cashless-card', params });
        }
    }
};
</script>
